
const state = {
    gradeRankOptions: [
        // { label: '药店', value: 1 },
        // { label: '诊所', value: 2 },
        // { label: '连锁', value: 3 },
        // { label: '商业', value: 4 },
    ],
}

const mutations = {
    SET_GRADE_RANK_OPTIONS(state, options) {
        state.gradeRankOptions = options
    }
}

const actions = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

